module.exports = __webpack_public_path__ + "static/media/mall-image-2.9bf72443.png";